var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwittershare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "twittershare",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.637,
    height: 66.637,
    viewBox: "0 0 66.637 66.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24422",
    "data-name": "Path 24422",
    d: "M33.318,0A33.318,33.318,0,1,0,66.636,33.318,33.319,33.319,0,0,0,33.318,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24423",
    "data-name": "Path 24423",
    d: "M282.294,268.4l13.471-15.705h-3.192l-11.7,13.637-9.342-13.637H260.759l14.127,20.621-14.127,16.47h3.192l12.352-14.4,9.866,14.4h10.775L282.294,268.4ZM265.1,255.1H270l22.57,32.38h-4.9Z",
    transform: "translate(-245.534 -237.938)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwittershare);
export default __webpack_public_path__ + "static/media/twittershare.64ab6bdc47bc6078e62951a32d1b6d00.svg";
export { ForwardRef as ReactComponent };